import { Box } from '@material-ui/core';

import { Font } from '@/components/shared/components/Font';
import { Icon } from '@/components/shared/components/Icon';
import { Text } from '@/components/shared/components/Text';
import { useCustomTheme } from '@/hooks/useCustomTheme';

export const PendingBorrowerNameInformation = () => {
  const { palette } = useCustomTheme();

  return (
    <Box display={'flex'} alignItems={'center'} style={{ opacity: 0.5 }}>
      <Icon size={20} color={palette.text.secondary} style={{ paddingRight: '8px' }}>
        schedule
      </Icon>
      <Font variant="subtitle2" color={'textPrimary'}>
        <Text tId={'PENDING_INFORMATION'} />
      </Font>
    </Box>
  );
};
